import * as React from 'react';
import { Button } from 'semantic-ui-react';
import DrawerComponent from '../../shared/component/drawer_component';
import { Position, Drawer } from '@blueprintjs/core';
import SortableSelectionList  from '@webpt/bonfire/dist/es6/components/SortableSelectionList/SortableSelectionList';
import { deepCopy } from '../util/patient_ledger_utility';

interface Item {
    id: string;
    label: string;
    checked: boolean;
}

interface PatientLedgerDrawerProps {
    isOpen: boolean;
    onClose: (unsaved_changes: boolean, changed_items?: Item[]) => void;
    onApply?: (selectedItems: Item[]) => void;
    initConfigItems?: Item[];
}

interface PatientLedgerDrawerState {
    hasUserInteracted: boolean;
    submitConfigItems?: Item[];
    initialized: boolean;
    allowSave: boolean;
}

class PatientLedgerDrawerComponent extends React.Component<PatientLedgerDrawerProps, PatientLedgerDrawerState> {
    constructor(props: PatientLedgerDrawerProps) {
        super(props);
        this.state = {
            hasUserInteracted: false,
            initialized: false,
            allowSave: true
        };
    }

    componentDidUpdate(prevProps: PatientLedgerDrawerProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({
                hasUserInteracted: false,
                initialized: false
            });
        }
    }

    handleSelectionChange = (selectedItems: Item[]) => {
        if (this.state.initialized) {
            if (selectedItems.filter((item) => item.checked).length > 0) {
                this.setState({
                    hasUserInteracted: true,
                    submitConfigItems: selectedItems,
                    allowSave: true
                });
            } else {
                this.setState({
                    allowSave: false
                });
            }
        } else {
            this.setState({
                hasUserInteracted: false,
                initialized: true
            })
        }
    };

    handleApply = () => {
        if (this.state.hasUserInteracted && this.state.submitConfigItems.length > 0 && this.props.onApply) {
            this.props.onApply(this.state.submitConfigItems);
        }
        this.props.onClose(false);
    };

    onDrawerClosed = () => {
        if (!this.state.allowSave) return;
        if (this.state.hasUserInteracted) {
            this.props.onClose(true, this.state.submitConfigItems);
        }
        else {
            this.props.onClose(false);
        }
    }

    render() {
        return (
            this.props.isOpen && <DrawerComponent
                key="patient-ledger-drawer"
                canOutsideClickClose={false}
                canEscapeKeyClose={false}
                isOpen={this.props.isOpen}
                className="ext-bp-drawer patient-ledger-drawer"
                handleDrawerClose={this.onDrawerClosed}
                position={Position.RIGHT}
                title=""
                isCloseButtonShown={true}
                disableAutoClose={true}
                innerContent={
                    <div>
                        <div className="patient-ledger-drawer-apply-btn-container">
                            <Button
                                id='id_btn_apply_ledger_entry'
                                type='button'
                                primary
                                content="Apply"
                                size="small"
                                className="patient-ledger-drawer-apply-btn"
                                onClick={this.handleApply}
                                disabled={!this.state.hasUserInteracted || !this.state.allowSave}
                            />
                        </div>
                        <div className="patient-ledger-drawer-title">
                            <h1>Edit Columns</h1>
                        </div>
                        <div className="patient-ledger-drawer-content">
                            <div>
                                <SortableSelectionList
                                    items={this.props.initConfigItems}
                                    onSelectionChange={this.handleSelectionChange}
                                    className="patient-ledger-column-list"
                                    style={{ width: "350px", maxWidth: "350px", border: "1px solid gray", padding: "4px" }}
                                    id="patient-ledger-column-selector"
                                />
                            </div>
                        </div>
                    </div>
                }
                size={Drawer.SIZE_SMALL}
            />
        );
    }
}

export default PatientLedgerDrawerComponent;
